import { render, staticRenderFns } from "./wf-parallel-radio-buttons-filled-edit.vue?vue&type=template&id=8b03fa64&scoped=true&"
import script from "./wf-parallel-radio-buttons-filled-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-parallel-radio-buttons-filled-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-parallel-radio-buttons-filled-edit.vue?vue&type=style&index=0&id=8b03fa64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b03fa64",
  null
  
)

export default component.exports